import { clone } from '@edicom/common/object/clone';

export function actionsFactory(treeNodes, getValueFromScope, getPathFromModel, createTreeData, findParentNode) {
  return { create, insert, duplicate, remove };

  function create() {
    return new Promise(resolve => {
      insertDataInRoot();
      resolve();
    });
  }

  function insert(selected = [], path = '') {
    if (!path) {
      // el path es obligatorio para cuando tenemos varios tipos de hijos distintos posibles
      return;
    }
    const promises = selected.map(node => {
      return insertData(node, path).catch(() => {
        /* si no hay registro hijo, no hacemos nada */
      });
    });
    return Promise.all(promises).then(res => {
      return res.filter(({ node }) => node);
    });
  }

  function duplicate(selected = []) {
    const promises = selected.map(node => {
      return insertData(findParentNode(node), node.path, clone(node.data)).catch(() => {
        /* si no hay registro hijo, no hacemos nada */
      });
    });
    return Promise.all(promises).then(res => {
      return res.filter(({ node }) => node);
    });
  }

  function remove(selected = []) {
    return new Promise(resolve => {
      selected.forEach(node => {
        const { parentRegister, registerName, register } = extractRegistersFromNode(node);

        // si el usuario borra un hijo y su padre a la vez,
        // el parentRegister[registerName] del hijo puede que no existe ya si el padre se borro primero
        // en cuyo caso no hacemos nada ya que el registro completo ya esta borrado
        if (parentRegister[registerName] && Array.isArray(parentRegister[registerName])) {
          const index = parentRegister[registerName].findIndex(cur => cur === register);
          parentRegister[registerName].splice(index, 1);
        }
      });

      resolve();
    });
  }

  function extractRegistersFromNode(node) {
    const parentRegister = getValueFromScope(
      node.model
        .split('.')
        .slice(0, -1)
        .join('.')
    );
    const array = getValueFromScope(
      node.model
        .split('.')
        .slice(0, -1)
        .join('.')
    );
    const registerName = node.path
      .split('.')
      .slice(-1)
      .join('.');
    const register = node.data;
    return { parentRegister, registerName, register, array };
  }

  // /**
  //  * Devuelve el xPath del nodo hijo al que queremos insertar
  //  *
  //  * @param {object} node el nodo del tree al que queremos insertar
  //  * @return {string}
  //  */
  // function getChildPath(node) {
  //   const path = getPathFromModel(node.id);
  //   const childIndex = treeNodes.indexOf(path) + 1;
  //   if (!treeNodes[childIndex]) {
  //     throw new Error(`Este registro "${path}" no tiene hijos`);
  //   }
  //   const childRegisterPath = treeNodes[childIndex];
  //   return childRegisterPath;
  // }

  /**
   * Devuelve true si es el nodo root.
   * El nodo root es del ewc-tree, no contiene datos de la pantalla
   *
   * @param {object} node el nodo
   * @return {boolean}
   */
  function isRoot(node) {
    return !node.data;
    // return node.depth === -1;
  }

  /**
   * Inserta un nuevo hijo en los datos del nodo.
   * Despues actualiza los children del nodo para que se pueda refrescar solo ese nodo en el tree.
   * Devuelve una promesa que devuleve el nodo con los children actualizados.
   *
   * /!\ NOTA: solo funciona si un nodo solo puede tener un tipo de hijo /!\
   *
   * @param {object} node el nodo al que se le va insertar un nuevo hijo
   * @param {object} data los datos del registro hijo que vamos a insertar
   * @return {Promise} La promesa devuelve el nodo actualizado para el tree
   */
  function insertData(node, path, data = {}) {
    if (isRoot(node)) {
      // el padre es el root del ewc-tree, no tiene node.data.register etc... insertamos de otra forma:
      return insertDataInRoot(data);
    }
    // recuperamos el nombre del campo
    const field = path.split('.').pop();
    // recuperamos los datos del regitro
    const register = node.data;
    // inicializamos el array hijo
    register[field] = register[field] || [];
    // añadimos el nuevo objeto vacio al registro hijo
    register[field].push(data);
    // createTreeData(register, getPathFromModel(node.data.model)).then(newData => {
    return createTreeData(register, node.model).then(childrenUpdated => {
      // cloneamos el nodo para no modificarlo sino da problemas en el ewcTree
      const newId = childrenUpdated.find(elem => elem.data === data)?.id;

      const newNode = clone(node);
      // // binding de los datos. Eso si que necesitamos que se pase por referencia
      newNode.data = node.data;
      // registramos los hijos actualizados
      newNode.children = childrenUpdated;
      // devolvemos en nuevo nodo que se va actualizar y refrescar en el ewcTree
      return { node: newNode, newId };
      // node.children = childrenUpdated;
      // return node;
    });
    // // calculamos el id del nuevo registro
    // const index = register[field].length - 1;
    // const id = `${node.id}.${field}[${index}]`;
    // return id;
  }

  /**
   * Inserta un nuevo hijo en los datos del nodo root.
   * Es decir inserta en el primer nivel.
   * Devuelve el nuevo id de el nuevo nodo que ha insertado.
   *
   * @param {object} [data={}] - los datos a insertar
   * @return {Promise} la promesa no devuelve nada (para que recargue el tree completo)
   */
  function insertDataInRoot(data = {}) {
    const register = getValueFromScope(treeNodes[0]);
    register.push(data);
    return Promise.resolve();
    // const index = register.length - 1;
    // const id = `${treeNodes[0]}[${index}]`;
    // return id;
  }
}
